// src/pages/finance/MisiManagementPage.js
import React, { useEffect, useState } from 'react'
import { collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore'
import { db } from '../../firebaseConfig'

export default function MisiManagementPage() {
  const [history, setHistory] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // 🔹 Membaca riwayat klaim misi dari database global
    const q = query(
      collection(db, 'mission_claim_logs'), 
      orderBy('createdAt', 'desc'),
      limit(100)
    )

    const unsub = onSnapshot(q, (snap) => {
      const data = snap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
      setHistory(data)
      setLoading(false)
    })

    return () => unsub()
  }, [])

  return (
    <div>
      <h2 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
        🎯 Riwayat Klaim Misi Mitra
      </h2>

      <div className="bg-gray-800 border border-gray-700 rounded-lg overflow-hidden shadow-xl">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm text-gray-300">
            <thead className="bg-gray-700 text-gray-400 uppercase font-semibold">
              <tr>
                <th className="px-6 py-3">Waktu</th>
                <th className="px-6 py-3">Mitra</th>
                <th className="px-6 py-3">Judul Misi</th>
                <th className="px-6 py-3">Nominal Bonus</th>
                <th className="px-6 py-3">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700">
              {loading ? (
                <tr><td colSpan="5" className="p-6 text-center">Loading data...</td></tr>
              ) : history.length === 0 ? (
                <tr><td colSpan="5" className="p-6 text-center">Belum ada aktivitas misi.</td></tr>
              ) : (
                history.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-700/50 transition">
                    <td className="px-6 py-3 text-xs text-gray-400">
                      {item.createdAt?.toDate().toLocaleString('id-ID')}
                    </td>
                    <td className="px-6 py-3">
                      <div className="font-medium text-white">{item.mitraUid?.substring(0, 8)}...</div>
                      <div className="text-xs text-gray-500 capitalize">{item.mitraType}</div>
                    </td>
                    <td className="px-6 py-3">
                      <span className="font-semibold text-blue-400">{item.missionScope || 'Misi'}</span>
                    </td>
                    <td className="px-6 py-3 font-bold text-green-400">
                      Rp {(item.bonus || 0).toLocaleString('id-ID')}
                    </td>
                    <td className="px-6 py-3">
                      {item.approved === true ? (
                        <span className="bg-green-900/50 text-green-400 px-2 py-1 rounded border border-green-700 text-xs font-bold">BERHASIL</span>
                      ) : item.rejected === true ? (
                        <div className="flex flex-col">
                           <span className="bg-red-900/50 text-red-400 px-2 py-1 rounded border border-red-700 text-xs font-bold w-fit">DITOLAK</span>
                           <span className="text-[10px] text-red-300 mt-1 italic">{item.rejectedReason}</span>
                        </div>
                      ) : (
                        <span className="bg-yellow-900/50 text-yellow-400 px-2 py-1 rounded border border-yellow-700 text-xs font-bold">PENDING</span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}